import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {BehaviorSubject, finalize, tap} from 'rxjs';
import {SnackbarService} from 'src/app/services/snackbar.service';
import {UnitBankAccountService} from '../unit-bank-account/unit-bank-account.service';

@Component({
  selector: 'terra-unit-bank-account-verification-letter',
  templateUrl: './unit-bank-account-verification-letter.component.html',
  styleUrls: ['./unit-bank-account-verification-letter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnitBankAccountVerificationLetterComponent implements OnInit {

  isDownloading$ = new BehaviorSubject<boolean>(false);

  includeBalance = new UntypedFormControl(false);

  constructor(
    private unitBankAccountService: UnitBankAccountService,
    private snackbarService: SnackbarService
  ) {
  }

  ngOnInit(): void {
  }

  generateVerificationLetter() {
    this.isDownloading$.next(true);
    const id: boolean = this.includeBalance.value;
    this.unitBankAccountService.generateVerificationLetter(id).pipe(
      tap(() => this.isDownloading$.next(false))
    ).subscribe(
      _ => {
        this.snackbarService.showGeneralMessage('Banking Verification Letter Downloaded');
        this.includeBalance.setValue(false);
        this.includeBalance.updateValueAndValidity();
      }
    );
  }
}
